import { handleVersionMismatch } from 'actions/versionSync';
import * as ExchangeActionTypes from 'actiontypes/exchange';
import { VersionMismatch } from 'services/BaseService';

import ExchangeService from 'services/ExchangeService';

const exchangeService = new ExchangeService();

/** ----------------------------------------------------------------------------
 * FETCH AVAILABLE ITEMS
 -----------------------------------------------------------------------------*/

type FetchAvailableOptions = {
  background?: boolean,
};

const fetchAvailableItems = (shopId: number | null, options?: FetchAvailableOptions) => async (dispatch: Function) => {
  dispatch(fetchAvailableItemsRequested(options?.background ?? false));

  try {
    const { data } = await exchangeService.fetchAvailableItems(shopId);
    // TODO: populate Redux store without forcing a UI update
    dispatch(fetchAvailableItemsSuccess(data, shopId));
  } catch (e) {
    if (e instanceof VersionMismatch) {
      dispatch(handleVersionMismatch(e));
    }
    dispatch(fetchAvailableItemsFailure(e));
  }
};

export default fetchAvailableItems;

const fetchAvailableItemsRequested = (background: boolean) => ({
  type: ExchangeActionTypes.FETCH_AVAILABLE_REQUESTED,
  payload: { background },
});

const fetchAvailableItemsSuccess: (data: any, shopId: any) => FetchAvailableItemsSuccess = (data, shopId) => ({
  type: ExchangeActionTypes.FETCH_AVAILABLE_SUCCESS,
  isFetchingAvailable: false,
  payload: {
    activeStore: null,
    id: shopId,
    items: data,
  },
});

const fetchAvailableItemsFailure = (error: any) => ({
  type: ExchangeActionTypes.FETCH_AVAILABLE_FAILURE,
  isFetchingAvailable: false,
  error: true,
  status: error.response && error.response.status,
});

export type FetchAvailableItemsSuccess = {
  type: string,
  payload: {
    activeStore: null,
    id: number,
    items: any,
  },
};
